"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Modal_1 = __importDefault(require("@material-ui/core/Modal"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const Text_1 = __importDefault(require("../Text"));
const variables_1 = __importDefault(require("../../styles/variables"));
const Icon_1 = require("../Icon");
const useStyles = (0, core_1.makeStyles)((theme) => ({
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    modalBody: {
        margin: '1rem 0',
    },
    modalActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: '1rem',
        '& > *:not(:first-child)': {
            marginLeft: '1rem',
        },
    },
    modalContent: {
        backgroundColor: variables_1.default.colors.surface.default,
        borderRadius: '8px',
        padding: '24px',
        position: 'absolute',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    modalTitle: {
        fontSize: variables_1.default.fonts.size.h4,
        fontFamily: variables_1.default.fonts.family.heading,
        color: variables_1.default.colors.text.default,
        [theme.breakpoints.only('sm')]: {
            fontSize: variables_1.default.fonts.size.h3,
        },
    },
    closeButton: {
        cursor: 'pointer',
    },
    sm: {
        width: variables_1.default.breakpoints.sm,
        maxWidth: '95%',
    },
    md: {
        width: variables_1.default.breakpoints.md,
        maxWidth: '95%',
    },
    lg: {
        width: variables_1.default.breakpoints.lg,
        maxWidth: '95%',
    },
    xl: {
        width: variables_1.default.breakpoints.xl,
        maxWidth: '95%',
    },
}));
function ModalHeader({ showCloseButton = true, onClose, children, className, }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.modalHeader, className) }, showCloseButton ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null, children),
        react_1.default.createElement(core_1.IconButton, { size: "small", onClick: onClose },
            react_1.default.createElement(Icon_1.RegularIcon, { icon: "close" })))) : (children)));
}
function ModalBody({ children, className, }) {
    const classes = useStyles();
    return react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.modalBody, className) }, children);
}
function ModalActions({ children, className, }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.modalActions, className) }, children));
}
function Modal({ allowAutoClose = false, open = false, title = undefined, size = 'md', className = undefined, dismissible = true, onClose, children, classes: modalClasses, dataTestId, ...rest }) {
    const classes = useStyles();
    return (react_1.default.createElement(Modal_1.default, { open: open, onClose: allowAutoClose ? onClose : undefined, ...rest },
        react_1.default.createElement("div", { className: (0, clsx_1.default)(classes[size], classes.modalContent, className) },
            !!title?.length && (react_1.default.createElement(ModalHeader, { showCloseButton: dismissible, onClose: onClose, className: modalClasses?.modalHeader },
                react_1.default.createElement(Text_1.default, { as: "h4", className: classes.modalTitle, "data-testid": dataTestId }, title))),
            children)));
}
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Actions = ModalActions;
exports.default = Modal;
